import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import { useState } from 'react';

import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import NameField from 'components/forms/new/formikFormFields/NameField';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const RegistrarNameField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            isRequired
            isInvalid={!!errors.name && touched.name}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Registrar Name
                </FormLabel>
                <Field
                    name="name"
                    render={({ field }) => (
                        <NameField
                            {...field}
                            pl={2}
                            placeholder="Enter registrar name"
                            label="Registrar Name *"
                            darkMode={darkMode}
                        />
                    )}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Enter a unique, friendly name to identify this SIP registrar configuration. This name is for your reference only."
                        ariaLabel="registrar-name-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FieldError error={errors?.name} touched={touched?.name} />
        </FormControl>
    );
};

export default RegistrarNameField;
